export default __webpack_public_path__ + "static/media/empty.f531b822.png";